import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import { useToken } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { PrimaryIconButton, OutlineButton } from '@rexlabs/button'; // TODO: Fix type
// eslint-disable-next-line
// @ts-ignore

import AddIcon from '@rexlabs/icons/add.svg'; // TODO: Fix type
// eslint-disable-next-line
// @ts-ignore

import CloseIcon from '@rexlabs/icons/close-large.svg';
import { useFieldArray } from './core';
import Field from './field';
import { isFunction } from 'lodash';

function DefaultFieldArray(_ref) {
  var fields = _ref.fields,
      push = _ref.push,
      label = _ref.label,
      rest = _objectWithoutProperties(_ref, ["fields", "push", "label"]);

  var token = useToken();
  return /*#__PURE__*/React.createElement(Box, {
    flexDirection: "column",
    sy: token('spacing.s')
  }, _mapInstanceProperty(fields).call(fields, function (_ref2, index) {
    var field = _ref2.field,
        actions = _ref2.actions;
    return /*#__PURE__*/React.createElement(Box, {
      key: field.name,
      alignItems: "flex-end"
    }, /*#__PURE__*/React.createElement(Box, {
      flex: 1
    }, /*#__PURE__*/React.createElement(Field, _extends({}, rest, field, {
      label: index === 0 ? label !== null && label !== void 0 ? label : undefined : undefined,
      fullWidth: true
    }))), /*#__PURE__*/React.createElement(Box, {
      flex: 0,
      alignItems: "center",
      ml: token('spacing.s')
    }, /*#__PURE__*/React.createElement(PrimaryIconButton, {
      Icon: CloseIcon,
      onClick: function onClick() {
        var _actions$remove;

        actions === null || actions === void 0 ? void 0 : (_actions$remove = actions.remove) === null || _actions$remove === void 0 ? void 0 : _actions$remove.call(actions);
      }
    })));
  }), /*#__PURE__*/React.createElement(Box, {
    flex: 0
  }, /*#__PURE__*/React.createElement(OutlineButton, {
    IconLeft: AddIcon,
    onClick: function onClick() {
      return push(null);
    }
  }, "Add another")));
}

function FieldArray(_ref3) {
  var name = _ref3.name,
      children = _ref3.children,
      render = _ref3.render,
      Input = _ref3.Input,
      rest = _objectWithoutProperties(_ref3, ["name", "children", "render", "Input"]);

  var _useFieldArray = useFieldArray(name),
      _useFieldArray2 = _slicedToArray(_useFieldArray, 2),
      fields = _useFieldArray2[0],
      actions = _useFieldArray2[1];

  var props = useMemo(function () {
    return _objectSpread(_objectSpread({}, actions), {}, {
      fields: fields,
      getFieldProps: function getFieldProps(field) {
        return field;
      }
    });
  }, [fields, actions]);

  if (isFunction(children)) {
    return children(props);
  }

  if (isFunction(render)) {
    return render(props);
  }

  if (Input) {
    return /*#__PURE__*/React.createElement(DefaultFieldArray, _extends({
      Input: Input
    }, rest, props));
  }

  return null;
}

export default FieldArray;